import { render, staticRenderFns } from "./new-menu-left.vue?vue&type=template&id=41dcd25a&scoped=true&"
import script from "./new-menu-left.vue?vue&type=script&lang=js&"
export * from "./new-menu-left.vue?vue&type=script&lang=js&"
import style0 from "./new-menu-left.vue?vue&type=style&index=0&id=41dcd25a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dcd25a",
  null
  
)

export default component.exports